import { TableException } from "./TableException";

export class ClosingTableException extends TableException {

    constructor () {
        super(`A mesa está em fechamento`);
    }

    get variables () {
        return {}
    }

    get template () {
        return "closingTableException";
    }

}
